export enum PmsIntegrationTypeEnum {
    LibertyRx = 'LibertyRx', 
    PioneerRx = 'PioneerRx',
    FrameworkLTC = 'FrameworkLTC'
}